var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_3844)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69457 1.56104H14.8917C18.1102 1.56104 20.2494 3.85831 20.2494 7.15505V14.8785C20.2494 18.1754 18.1101 20.4725 14.8908 20.4725H6.69457C3.47618 20.4725 1.33789 18.1754 1.33789 14.8785V7.15505C1.33789 3.86124 3.48191 1.56104 6.69457 1.56104ZM14.892 2.97962H6.69479C4.28862 2.97962 2.75647 4.62339 2.75647 7.15528V14.8787C2.75647 17.4141 4.28335 19.0544 6.69479 19.0544H14.8911C17.3035 19.0544 18.8312 17.414 18.8312 14.8787V7.15528C18.8312 4.62015 17.3037 2.97962 14.892 2.97962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24805 11.0164H14.3398",
    stroke: "white",
    strokeWidth: 1.34744,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_3844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusRound);
export default __webpack_public_path__ + "static/media/minus-round.ee3973ad7760d0145c3e8a5a691ca7f0.svg";
export { ForwardRef as ReactComponent };